import { searchString } from '@/services/router/search-scalars';

/**
 * The new-import screen's search params.
 *
 * Every one is a seed from the screen that sent the reader here: the segment, object or people
 * pages name what they want imported so the upload screen opens with it already chosen. Declared
 * here so those links are typed and a deep link survives validation.
 */
export type NewImportSearch = {
  /** Which type to preselect. Ignored unless it names a type the screen offers. */
  type?: string;
  /** The object type to import into, for `type=object`. */
  objectTypeId?: string;
  /** The segment whose people are being imported. */
  segmentId?: string;
  /** The screen that linked here, so Cancel returns to it instead of its default. */
  previousRouteName?: string;
  /** `true` points the reader at the sample-data rail until they touch it. */
  highlightSampleData?: string;
};

/**
 * `validateSearch` replaces this route's search, so the incoming params are spread to preserve
 * the global ones the page does not own (`masq_account_id`, …) and only the seeds are narrowed.
 */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
export function validateNewImportSearch(search: Record<string, unknown>): Record<string, unknown> & NewImportSearch {
  return {
    ...search,
    type: searchString(search.type),
    objectTypeId: searchString(search.objectTypeId),
    segmentId: searchString(search.segmentId),
    previousRouteName: searchString(search.previousRouteName),
    highlightSampleData: searchString(search.highlightSampleData),
  };
}
